import React from "react";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import PaymentFileUploader from "./PaymentFileUploader";
import {usePolicyContext} from "./PolicyContext";
import PaymentFileViewer from "./PaymentFileViewer";
import {useFormikContext} from "formik";
import {ErrorCommon} from "../../formikFormInputs";
import {TO_BE_VOIDED} from "../../../constants";

function UploadVoidedCheck() {
    const fileType = "image/jpg, image/jpeg, image/png, application/pdf";
    const {policy} = usePolicyContext();
    const {values, setFieldValue, errors, touched}: any = useFormikContext();
    const policyNumber = policy && policy.policyNumber;
    const setFrontPath = (filePath: string) => {
        filePath = filePath.replace(new RegExp('ToBeVoided', 'i'), ''); // hack to remove ToBeVoided after upload
        setFieldValue('checkFrontPath', filePath);
    };

    return (
            <>
                <Grid item xs={12}>
                    <Typography variant="body1" component="strong" className="floatLeft w100 mb0">
                        Upload Voided Check
                    </Typography>
                    <Typography variant="caption" className="floatLeft w100 mb0">
                        The policy holder must be a signor on the account. Only personal accounts are acceptable. No
                        business accounts will be accepted.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    {
                            !values.checkFrontPath && <>
                                <PaymentFileUploader
                                        isSecuredSignedUrl={true}
                                        fileType={fileType}
                                        dirName={policy && policy.policyNumber}
                                        fileName={`${TO_BE_VOIDED}FrontOfCheck`}
                                        setFileName={setFrontPath}
                                        title="Upload check front"
                                />
                                <ErrorCommon
                                        errors={errors}
                                        name={"checkFrontPath"}
                                        touched={touched}
                                />
                            </>
                    }
                    {
                            values.checkFrontPath &&
                            <PaymentFileViewer
                                    fileName={values.checkFrontPath}
                                    policyNumber={policyNumber}
                                    title={"Front of Check"}
                                    readOnly={false}
                                    deleteFile={() => {
                                        setFrontPath('');
                                    }}
                            />
                    }
                </Grid>
            </>
    );
}

export default UploadVoidedCheck;